export const reverseArray = <T>(arr: T[]): T[] => {
  return [...arr].reverse()
}
